import { Component } from '@angular/core';

@Component({
	templateUrl: '../../../../../../assets/svg/invoices.svg',
})
export class InvoicesComponent {}
